import React, { useState, useContext } from 'react'
import './index.scss'
import selectIcon from '../../assets/images/ic_select.png'
import selectedIcon from '../../assets/images/ic_selected.png'
import showMore from '../../assets/images/ic_showmore.png'
import showLess from '../../assets/images/ic_showless.png'
import { ICateGoryItem } from '../FirstCategory'

import { CategoriesContext } from '../../lib/context'

interface ICateGory {
    secondCategory: ICateGoryItem
}
const SecondCategory = (props: ICateGory) => {
    const { secondCategory } = props
    const { category, children } = secondCategory
    const categoriesContext: any = useContext(CategoriesContext)
    const [showChildren, setshowChildren] = useState(false)
    const selectCategory = id => {
        categoriesContext?.clickCategory(id)
    }
    let isSelect = categoriesContext?.selectCategory.indexOf(category.id) !== -1
    return (
        <>
            <div className="second">
                <div
                    className="leftCategory"
                    onClick={() => selectCategory(category.id)}
                >
                    <img
                        className="selectIcon"
                        src={isSelect ? selectedIcon : selectIcon}
                        alt=""
                    ></img>
                    <span
                        className={`categoryName ${isSelect ? 'active' : ''}`}
                    >
                        {category.displayTerm}
                    </span>
                </div>
                <div
                    className="rightCategory"
                    onClick={() => setshowChildren(!showChildren)}
                >
                    {children && children.length > 0 && (
                        <img
                            className="rightIcon"
                            src={showChildren ? showLess : showMore}
                            alt=""
                        ></img>
                    )}
                </div>
            </div>
            {/*  */}
            <div className="thirdContent">
                {showChildren &&
                    children &&
                    children.map((item, index) => {
                        return (
                            <div
                                key={`third${index}`}
                                className={`thirdItem ${
                                    categoriesContext?.selectCategory.indexOf(
                                        item.category.id
                                    ) !== -1
                                        ? 'active'
                                        : ''
                                }`}
                                onClick={() =>
                                    selectCategory(item?.category?.id)
                                }
                            >
                                {item?.category?.displayTerm}
                            </div>
                        )
                    })}
            </div>
        </>
    )
}

export default SecondCategory
